import type { FaireProductEntity } from "../../entity_types/product";

export const p_kzyuf5tx9c: FaireProductEntity = {
  token: "p_kzyuf5tx9c",
  type: "product",
  name: "Aromatherapy Room & Body Mist – Pure Essential Oils",
  brandToken: "b_thcq7n2zrb",
  brandName: "Big Dipper Wax Works",
  imageUrl:
    "https://cdn.faire.com/fastly/5b1ab54d3c73723ad3b76a58f5c5ccdb727941e8ceb00cdf5193b8b2443c618a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aec5594a9a9d5378fc0d7ac32931989c277ad937a8d9ccbd8793aea96819fcbd.jpeg",
    "https://cdn.faire.com/fastly/a0f063b72816c2d3a1141b6e4b0c06bfa5c1d13d3f72b009ea4bcfea8b98234f.jpeg",
    "https://cdn.faire.com/fastly/f5b4747ecddd8bd8a1c19317d1fd663b1410a8eb8c12eb50088fcc9ba623dadd.jpeg",
    "https://cdn.faire.com/fastly/7e0ef66e6429aa81f772b643adcbde3919c5e4929e0146b8af53bf485f539500.jpeg",
    "https://cdn.faire.com/fastly/e3d2e3323a53f99e1ce8d595f263bf627f1257781ce96cf943d30dba8d59a7c1.jpeg",
    "https://cdn.faire.com/fastly/72c1bea2c32a919b74b362419542906911ed8b87efb1026bd7fa3bcbeb0a30f7.jpeg",
    "https://cdn.faire.com/fastly/6296949c40891ca2bd8d142c1f9891bcb63b582ee2ce45564ebb135f6ba77f3d.jpeg",
    "https://cdn.faire.com/fastly/67c4ae56b180732358400fb68e98cc80fd7854e4124fa444e83b98bf59afed80.jpeg",
    "https://cdn.faire.com/fastly/4c822ac498cdd35d9e8d800b00118c4602aa3520b712e0a6f4936474b6cc0927.jpeg",
    "https://cdn.faire.com/fastly/263705421f601f65ebaac7ccc1de1a85733150d019ac4946379a5b1c804145cf.jpeg",
    "https://cdn.faire.com/fastly/778b2453a3ba9da02e1967ac19b0265a3a194e9ad64134b6ff98f8418fe0d004.jpeg",
    "https://cdn.faire.com/fastly/25df2e9c57a4dc995c97711e3d739c146ca7a87acf9b45d9483ea3a29bafb048.jpeg",
    "https://cdn.faire.com/fastly/c9ba43107686c4fda454025d8b8c41aa34367391e01a18ef30e7bcf30346764b.jpeg",
    "https://cdn.faire.com/fastly/2d9040948856c780626882ef936863b115677be3bb4d5ec6ee4c828c80b46c74.jpeg",
    "https://cdn.faire.com/fastly/161044619f28bb6ca777ab44d4754283925bf2285fbb91e559e6def13f014e24.jpeg",
    "https://cdn.faire.com/fastly/e0808390a21fc0043febc821192333af814d98927e76c2e2960394b75d225e00.jpeg",
    "https://cdn.faire.com/fastly/c7d7d340ca0e59c194fa32a8709b39010e922bbb4bd19c12c2d7322ebc0f928d.jpeg",
  ],
  priceDollars: 7.97,
  description:
    "Refresh your space and uplift your senses with Big Dipper Wax Works Aromatherapy Mists. Made with purified water, vegetable glycerin, and pure essential oils, these versatile sprays deliver all-natural fragrance wherever you need it. Perfect as a room mist, body spray, or linen refresher, they provide a clean, non-toxic way to enhance your environment without burning candles.\n\nKeep one in your home, office, car, or bag for on-the-go aromatherapy anytime. Each 4 fl. oz bottle is hand-poured in small batches, ensuring quality and consistency.\n\nProduct Details\n\n-Size: 4 fl. oz spray bottle\n-Ingredients: Purified Water, Essential Oils, Vegetable Glycerin\n-Multi-use: Room Spray, Body Mist, Linen Spray\n\nUsage: Home Fragrance, Body Refresh, Travel Mist, Aromatherapy Boost\n\nNotes: Non-toxic, paraffin free, soy free, cruelty free, eco-friendly packaging.\n\nLearn more at BigDipperWaxWorks.com.\n",
  tags: [],
  msrpDollars: 15.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:58.704Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
